import common from "./common"
import navigate from "./navigate"


export default {
	...common,
	...navigate
}
